import React, {useContext, useState, useEffect} from 'react'
import {Grid} from 'semantic-ui-react'
import DesktopMenu from './DesktopMenu'
import MobileMenu from './MobileMenu'
import CartContext from '../Context/CartContext'
import SearchProvider from '../Context/SearchProvider'

const Negosyo = require('../../../lib/negosyo')


const Header = ({location, loggedIn, arrow}) => {
	const [isLogged, setIsLogged] = useState(null)
	const {cartCount} = useContext(CartContext)


	useEffect(()=>{
		checkLoggedIn()
	},[])

	const checkLoggedIn = () =>{
		//checking if logged in initially and for updating the header when logging out
		Negosyo.isLoggedIn()
		.then((data)=>{
			setIsLogged(data)
		}) //no catch since isLoggedIn won't reject promise
	}

	return (
		<React.Fragment>
			<SearchProvider>
				<Grid>
					<Grid.Column only='mobile tablet'>
						<MobileMenu
							location={location}
							token={isLogged || loggedIn}
							cartCount={cartCount}
							logout={Negosyo.logOut}
							recheckLoggedIn={checkLoggedIn}
							arrow={arrow}
						/>
					</Grid.Column>

				</Grid>
				<Grid>
					<Grid.Column only='computer'>
						<DesktopMenu
							location={location}
							token={isLogged || loggedIn}
							cartCount={cartCount}
							logout={Negosyo.logOut}
							recheckLoggedIn={checkLoggedIn}
						/>
					</Grid.Column>
				</Grid>
			</SearchProvider>
		</React.Fragment>
	)
}

export default Header
